import {ReactElement} from "react";
import commandAccessService from "command/commandAccessService";


/**
 * Component rendering children only if current user has access to execute a command.
 */
export default (props: {commandName: string, children: ReactElement}): ReactElement | null =>
  commandAccessService.canExecute(props.commandName) ? props.children : null